import { create } from 'zustand';

import type { AppState } from './types/appstate';
import type { Reaction } from './types/reaction';
import type { Tag } from './types/tag';
import type { User } from './types/user';

export const useStore = create<AppState>(() => ({
  profile: null as User | null,
  settings: {
    tags: [] as Tag[],
    reactions: [] as Reaction[],
  },
  notice: null,
  shareModal: {
    memoryId: null,
    timelineId: null,
  },
}));
